// Formatting helpers shared by the portal and the server.

export function formatTSh(amount: number | string | null | undefined): string {
  const n = Math.round(Number(amount) || 0);
  return 'TSh ' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// Accepts 0712345678, 712345678, +255 712 345 678 or 255712345678.
// Returns 255XXXXXXXXX, or null when it is not a Tanzanian mobile number.
export function normalizePhone(input: unknown): string | null {
  let d = String(input || '').replace(/\D/g, '');
  if (d.startsWith('255')) d = d.slice(3);
  else if (d.startsWith('0')) d = d.slice(1);
  if (!/^[67]\d{8}$/.test(d)) return null;
  return '255' + d;
}

// 255712345678 -> "0712 345 678"
export function displayPhone(phone: unknown): string {
  const n = normalizePhone(phone);
  if (!n) return String(phone || '');
  const local = '0' + n.slice(3);
  return `${local.slice(0, 4)} ${local.slice(4, 7)} ${local.slice(7)}`;
}

// The owner types the price any way they like ("35,000", "Tsh 35000/=", "35k").
// Returns a number when it is clearly one amount, otherwise null.
export function parsePrice(input: unknown): number | null {
  const s = String(input || '').trim().toLowerCase().replace(/tsh|tzs|sh\.?|\/=|-\/=/g, '').trim();
  const k = s.match(/^(\d+(?:[.,]\d+)?)\s*k$/);
  if (k) return Math.round(parseFloat(k[1]!.replace(',', '.')) * 1000);
  if (!/^\d{1,3}(?:[,.\s]\d{3})*$|^\d+$/.test(s)) return null;
  const n = Number(s.replace(/[,.\s]/g, ''));
  return n > 0 ? n : null;
}

// What the template prints for the price: formatted when we can, otherwise the owner's own words.
export function priceLabel(input: unknown): string {
  const n = parsePrice(input);
  if (n) return formatTSh(n);
  return String(input || '').trim();
}
